export const SECTION_TAB_KEYS = ['access', 'settings', 'birchstreet', 'billing'] as const;
export type RoutableTabKey = (typeof SECTION_TAB_KEYS)[number];
export const DEFAULT_TAB = 'dashboard';

const LEGACY_SECTION_ALIASES: Record<string, RoutableTabKey> = {
  users: 'access',
  authentication: 'access'
};

function resolveSegment(segment: string | undefined): RoutableTabKey | null {
  if (!segment) return null;
  if ((SECTION_TAB_KEYS as readonly string[]).includes(segment)) return segment as RoutableTabKey;
  return LEGACY_SECTION_ALIASES[segment] ?? null;
}

export function parseSectionFromLocation(location: string | string[] | undefined): RoutableTabKey | null {
  if (!Array.isArray(location)) return null;
  return resolveSegment(location[1]);
}

export function parseSectionFromPath(path: string | undefined): RoutableTabKey | null {
  if (!path) return null;
  const segments = path.split('?')[0].split('#')[0].split('/').filter(Boolean);
  if (segments[0] !== 'dashboard') return null;
  return resolveSegment(segments[2]);
}

export function tabKeyToSection(tabKey: string | null | undefined): RoutableTabKey | null {
  if (!tabKey) return null;
  return (SECTION_TAB_KEYS as readonly string[]).includes(tabKey) ? (tabKey as RoutableTabKey) : null;
}

export function getDashboardTabNavigationTarget(orgId: string, tabKey: string | null | undefined): string | null {
  if (tabKey === DEFAULT_TAB) return `/dashboard/${orgId}/`;
  const section = tabKeyToSection(tabKey);
  return section ? `/dashboard/${orgId}/${section}` : null;
}
